<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
      </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-1"></div>
        <div class="col-8">
          <b-form-group
              id="customNotificationOrder"
              :label-cols="5"
              label="Order"
              :state="stateForField('order')"
              :invalid-feedback="errorForField('order')"
              label-align="right">
            <b-form-input
                type="number"
                id="customNotificationOrderField"
                v-model="customNotification.order">
            </b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Name" :state="stateForField('name')" :invalid-feedback="errorForField('name')" label-align="right">
            <b-form-input v-model="customNotification.name"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Template" :state="stateForField('template')" :invalid-feedback="errorForField('template')" label-align="right">
            <b-form-textarea v-model="customNotification.template"></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveCustomNotification()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>
<script>
  import api from '@/services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  export default {
    name: 'CustomNotificationModal',
    mixins: [ErrorsMixin],
    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editCustomNotification: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        customNotification: {},
        isSaving: false
      }
    },
    watch: {
      editCustomNotification (newValue) {
        this.clearAllErrors()
        this.customNotification = newValue
      }
    },
    computed: {
      title () {
        if (this.customNotification && this.customNotification.organizationCustomNotificationId) {
          return 'Edit Custom Notification'
        }
        return 'Create Custom Notification'
      }
    },
    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.customNotification.order) {
          this.addErrorForField('order', 'You must add an order number')
        }

        if (!this.customNotification.name) {
          this.addErrorForField('name', 'You must add a name')
        }

        if (!this.customNotification.template) {
          this.addErrorForField('template', 'You must add a template')
        }

        return !this.hasErrors()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      saveCustomNotification () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        api.post('Dashboard/Organization/CustomNotifications', this.customNotification).then(response => {
          this.isSaving = false
          this.$emit('updated', response)
          this.customNotification = {}
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }
  }
</script>
